import { Link } from 'react-router-dom';
import { videos } from '@/mocks/videos';

export default function HotVideos() {
  const hotVideos = videos.filter((v) => v.isHot);
  const newVideos = videos.filter((v) => v.isNew);

  return (
    <section className="w-full px-4 md:px-6 py-10 md:py-14 bg-background-100/70">
      <div className="max-w-[1400px] mx-auto">
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
            热门推荐
          </h2>
          <Link to="/category/hot" className="text-sm text-primary-500 hover:text-primary-600 transition-colors flex items-center gap-1">
            更多热门 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {hotVideos.slice(0, 4).map((video) => (
            <VideoCard key={video.id} video={video} />
          ))}
        </div>

        <div className="flex items-center justify-between mb-6 mt-10">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
            最新上线
          </h2>
          <Link to="/category/hot" className="text-sm text-primary-500 hover:text-primary-600 transition-colors flex items-center gap-1">
            更多新片 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {newVideos.slice(0, 4).map((video) => (
            <VideoCard key={video.id} video={video} />
          ))}
        </div>
      </div>
    </section>
  );
}

function VideoCard({ video }: { video: typeof videos[0] }) {
  return (
    <Link
      to={`/article/${video.id}`}
      className="group bg-background-50 rounded-xl overflow-hidden hover:scale-[1.02] transition-all cursor-pointer data-product-shop"
      data-product-shop
    >
      <div className="relative aspect-video overflow-hidden">
        <img
          src={video.thumbnail}
          alt={video.title}
          title={`${video.title} - 蓝莓视频高清在线观看`}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-2 left-2 flex items-center gap-1.5">
          {video.isHot && (
            <span className="px-2 py-0.5 bg-primary-500 text-white text-xs rounded-md font-medium">
              热门
            </span>
          )}
          {video.isNew && (
            <span className="px-2 py-0.5 bg-accent-500 text-white text-xs rounded-md font-medium">
              新上
            </span>
          )}
        </div>
        <div className="absolute bottom-2 right-2 px-2 py-0.5 bg-black/70 text-white text-xs rounded">
          {video.duration}
        </div>
        <div className="absolute inset-0 bg-black/0 group-hover:bg-black/20 transition-colors flex items-center justify-center">
          <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-white/90 text-primary-500 opacity-0 group-hover:opacity-100 transition-all scale-75 group-hover:scale-100">
            <i className="ri-play-fill text-xl"></i>
          </div>
        </div>
      </div>
      <div className="p-3 md:p-4">
        <h3 className="text-sm md:text-base font-semibold text-foreground-900 line-clamp-1 mb-1">
          {video.title}
        </h3>
        <div className="flex items-center gap-3 text-xs text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-star-fill text-accent-500"></i>
            {video.rating}
          </span>
          <span>{video.views}次播放</span>
          <span className="ml-auto px-1.5 py-0.5 bg-background-200 rounded text-foreground-600 text-[10px]">
            {video.quality}
          </span>
        </div>
        {video.episodes && (
          <p className="text-xs text-foreground-500 mt-1">{video.episodes}</p>
        )}
      </div>
    </Link>
  );
}